import axios from 'axios'
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  // baseURL: '/api'
  baseURL: process.env.BASE_API // api 的 base_url
  // timeout: 5000 // request timeout
})

// response interceptor
service.interceptors.response.use(
  config => {
    config.headers['x-requested-with'] = 'XMLHttpRequest'
    return config
  }
)

service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    Message.error(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js